export default __webpack_public_path__ + "static/media/joaquin-ramiro@2x.1774faba.png";